export enum UserRole {
  Vendor = 'VENDOR', // Vendor Admin
  Team = 'TEAM', // Vendor Team Member
  Admin = 'ADMIN', // Brighte Admin
  Manager = 'MANAGER', // BDM
  SuperAdmin = 'SUPERADMIN', // Brighte Super Admin
  Client = 'CLIENT',
  AdminOperations = 'ADMIN_OPERATIONS',
  EnterpriseConcierge = 'ENTERPRISE_CONCIERGE',
  EnterprisePartner = 'ENTERPRISE_PARTNER',
  EnterprisePartnerPII = 'ENTERPRISE_PARTNER_PII',
  EnterpriseLead = 'ENTERPRISE_LEAD',
  Service = 'SERVICE',
}

export interface UserTokenPayload {
  'https://brighte.com.au/roles': UserRole[];
  role: UserRole;
  userId: string;
  vendors: string[];
  clientId: string;
  iss: string;
  sub: string;
  aud: string[];
  iat: number;
  exp: number;
  scope: string;
  id?: string;
  enterprisePartnerId?: string;
  opportunityId?: string;
}

export enum Scopes {
  // TO DO: Add scopes or change Larry
  PROFILE = 'profile',
  READ_USERS = 'read:user-details',
  READ_ENTERPRISE_APPLICATIONS = 'read:enterprise-partner-applications',
  READ_ENTERPRISE_LEADS = 'read:enterprise-leads',
  READ_ENTERPRISE_GROUPS = 'read:enterprise-groups',
  READ_ENTERPRISE_CONTACTS = 'read:enterprise-contacts',
  READ_ENTERPRISE_DOCUMENTS = 'read:enterprise-documents',
}
